import { addTestResult } from "../api/addTestResult";
import { getStudentData } from "./localStorage";
import { totalTimeOrScore } from "./scoreCounter";
import { answeredQues } from "./testHelper";

export default function submitQues(
  dispatchAnswer,
  dispatchHelper,
  answer = null,
  timeSpend,
  question,
  prevAns = null,
  answerAudio = null,
  testFormat, //need to send latter
  allQuestion,
  testType,
  skipAddTestResult
) {
  const answerRes = prevAns // this condition is for audio test
    ? [...prevAns, answeredQues(testFormat, answer, question, timeSpend)]
    : answerAudio;

  // let questions = [{ score_count: "total" }]
  // // special case for speed image recall test its question set different from another test
  // questions = question && question.testFormat === "listen_speak_series" ? questions : allQuestion
  const { player_time, player_score } = totalTimeOrScore(
    answerRes,
    allQuestion
  );
  const { login_id } = getStudentData();
  const grade_id =
    testType === "CALIBRATION"
      ? "5"
      : JSON.parse(localStorage.getItem("gradeId"));
  const formatValue = {
    grade_id,
    player_id: login_id,
    res: answerRes,
    player_image: "",
    player_time,
    player_score,
    test_id: question.test_id,
    skipAddTestResult,
  };

  addTestResult(formatValue, dispatchHelper, dispatchAnswer);

  if (prevAns) {
    // only for the test in which answer is not coming from the backend
    dispatchAnswer({
      type: "ADD_ANSWER",
      payload: answeredQues(testFormat, answer, question, timeSpend),
    });

    dispatchHelper({ type: "USER_INPUT", payload: false });
    dispatchHelper({ type: "IS_NEXT_QUES", payload: false });
  }
}
